import { Pipe, PipeTransform } from '@angular/core';
import {DataService} from "../../services/data.service";

@Pipe({
  name: 'stringBetween'
})
export class StringBetweenPipe implements PipeTransform {
  constructor(private ds: DataService) {}

  transform(str: string, char:string): any {
    if(!str?.includes(char)) return '';
    let lastIndex = str?.lastIndexOf(char);
    const specials= ['()','{}','[]','<>','--','**','!!','__','++'];
    if(this.ds.valueIsEither(char,specials.map(e=>e?.[0]))) {
      lastIndex = str.lastIndexOf(specials?.find(e => this.ds.valueIncludes(e,char[0]))?.[1]);
    }
    return str?.substring(str?.indexOf(char)+1,lastIndex);
  }


}
